/**
 * Gets the method of payment description for a subscription.
 * @param subsWithMop - The subscription with the method of payment.
 * @returns The method of payment description.
 */
export var getMopDescription = function getMopDescription(subsWithMop) {
  var _subsWithMop$myLatest, _venmo$username;
  var methodOfPayment = (_subsWithMop$myLatest = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest === void 0 || (_subsWithMop$myLatest = _subsWithMop$myLatest.cheggStudy) === null || _subsWithMop$myLatest === void 0 || (_subsWithMop$myLatest = _subsWithMop$myLatest.subscription) === null || _subsWithMop$myLatest === void 0 ? void 0 : _subsWithMop$myLatest.methodOfPayment;
  if (!methodOfPayment) return '';
  var mopInfo = methodOfPayment.mopInfo,
    mopHolderName = methodOfPayment.mopHolderName;
  var vbcAccountType = mopInfo.type,
    venmo = mopInfo.venmo;
  var fullName = mopHolderName ? "".concat(mopHolderName, "'s ") : '';
  switch (vbcAccountType) {
    case 'PAYPAL':
    case 'BRAINTREE_V_ZERO':
      return "".concat(fullName, "PayPal account");
    case 'APPLE_PAY':
    case 'BRAINTREE_APPLE_PAY':
      return "".concat(fullName, "Apple Pay");
    case 'GOOGLE_PAY':
      return "".concat(fullName, "Google Pay");
    case 'VENMO':
      return (_venmo$username = venmo === null || venmo === void 0 ? void 0 : venmo.username) !== null && _venmo$username !== void 0 ? _venmo$username : 'Venmo Account';
    default:
      return '';
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/nextInteractionUtil/getMopDescription.js
// module id = 4161
// module chunks = 11